import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppColors } from '../../../util/AppColors';

const NotFound = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");

  const handleGoHome = () => {
    if (token) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        textAlign="center"
        sx={{
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          minHeight: '100vh',
          padding: '20px'
        }}
      >
        {/* 404 Number */}
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '8rem', sm: '12rem' },
            fontWeight: 'bold',
            color: AppColors.appPrimary,
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
            marginBottom: '20px',
            lineHeight: 1
          }}
        >
          404
        </Typography>

        {/* Error Message */}
        <Typography
          variant="h4"
          sx={{
            color: '#333',
            marginBottom: '16px',
            fontWeight: 600,
            fontSize: { xs: '1.5rem', sm: '2rem' }
          }}
        >
          Oops! Page Not Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#666',
            marginBottom: '40px',
            fontSize: { xs: '1rem', sm: '1.1rem' },
            maxWidth: '500px'
          }}
        >
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </Typography>

        {/* Action Buttons */}
        <Box
          display="flex"
          gap={2}
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={handleGoHome}
            sx={{
              backgroundColor: AppColors.appPrimary,
              color: 'white',
              padding: '12px 32px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: AppColors.appPrimary,
                opacity: 0.9
              },
              minWidth: '160px'
            }}
          >
            {token ? 'Go to Dashboard' : 'Go to Login'}
          </Button>

          <Button
            variant="outlined"
            onClick={handleGoBack}
            sx={{
              borderColor: AppColors.appPrimary,
              color: AppColors.appPrimary,
              padding: '12px 32px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              '&:hover': {
                borderColor: AppColors.appPrimary,
                backgroundColor: 'rgba(106, 182, 255, 0.1)'
              },
              minWidth: '160px'
            }}
          >
            Go Back
          </Button>
        </Box>

        {/* Decorative Elements */}
        <Box
          sx={{
            position: 'absolute',
            top: '10%',
            right: '10%',
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: `linear-gradient(45deg, ${AppColors.appPrimary}20, ${AppColors.appPrimary}40)`,
            animation: 'float 6s ease-in-out infinite'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: '10%',
            left: '10%',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: `linear-gradient(45deg, ${AppColors.appPrimary}30, ${AppColors.appPrimary}50)`,
            animation: 'float 8s ease-in-out infinite reverse'
          }}
        />

        <style>
          {`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
          `}
        </style>
      </Box>
    </Container>
  );
};

export default NotFound; 